@if (hasResult || !hide()) {
  <ng-content></ng-content>
}
@if (isEmpty) {
  <ng-content select="[empty]"></ng-content>
}
@if (isLoading | async) {
  <ml-sk-spinner-3></ml-sk-spinner-3>
}